// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"149":"f752c86c7ba3c186","561":"138dfa6cf91173ef","865":"9c0316158cda7bcc"}[chunkId] + ".js";
};